module.exports = __webpack_public_path__ + "img/floor_EG-en.692d6e69.svg";